// Configuración del SDK de Culqi
// Documentación: https://docs.culqi.com/es/documentacion/checkout/v4/inicio/

// Claves públicas (estas van en el frontend)
// IMPORTANTE: Reemplazar con tus claves reales de Culqi
const CULQI_PUBLIC_KEY = process.env.REACT_APP_CULQI_PUBLIC_KEY || 'pk_test_90667d0a57d45c48';

// Inicializar Culqi Checkout
export const initCulqi = () => {
  if (typeof window !== 'undefined' && !window.Culqi) {
    const script = document.createElement('script');
    script.src = 'https://checkout.culqi.com/js/v4';
    script.async = true;
    script.onload = () => {
      console.log('Culqi SDK cargado');
    };
    document.body.appendChild(script);
  }
};

// Configurar Culqi con la llave pública
export const configureCulqi = () => {
  if (window.Culqi) {
    window.Culqi.publicKey = CULQI_PUBLIC_KEY;
    window.Culqi.init();
  }
};

// Configuración para crear token de tarjeta
export const createCardToken = async (cardData) => {
  return new Promise((resolve, reject) => {
    if (!window.Culqi) {
      reject(new Error('Culqi SDK no está cargado'));
      return;
    }

    window.Culqi.createToken();
    
    window.culqi = () => {
      if (window.Culqi.token) {
        resolve(window.Culqi.token);
      } else if (window.Culqi.error) {
        reject(window.Culqi.error);
      }
    };
  });
};

// Configuración de planes de suscripción
export const SUBSCRIPTION_PLANS = {
  basic: {
    id: 'plan_basic_mensual',
    name: 'Plan Básico',
    amount: 2900, // Culqi maneja montos en céntimos (S/ 29.00)
    currency: 'PEN',
    interval: 'monthly',
    interval_count: 1,
    trial_days: 7, // 7 días de prueba
    metadata: {
      features: [
        'Preguntas ilimitadas',
        'Explicaciones completas',
        'Estadísticas avanzadas',
        '5 simulacros mensuales',
        'Historial de progreso',
        'Acceso desde 2 dispositivos',
        'Sin publicidad'
      ]
    }
  },
  premium: {
    id: 'plan_premium_mensual',
    name: 'Plan Premium',
    amount: 4900, // S/ 49.00
    currency: 'PEN',
    interval: 'monthly',
    interval_count: 1,
    trial_days: 7,
    metadata: {
      features: [
        'Todo del plan Básico',
        'Predicción IA personalizada',
        'Descargas PDF ilimitadas',
        'Simulacros ilimitados',
        'Análisis de puntos débiles',
        'Recomendaciones de estudio',
        'Acceso desde 5 dispositivos',
        'Soporte prioritario',
        'Acceso a funciones beta'
      ]
    }
  }
};

// Configuración para Yape
export const configureYapePayment = (amount, description) => {
  return {
    amount: amount * 100, // Convertir a céntimos
    currency_code: 'PEN',
    email: '', // Se llenará con el email del usuario
    source_id: 'yape', // Identificador para Yape
    description: description,
    metadata: {
      payment_method: 'yape'
    }
  };
};

// Configuración para Plin
export const configurePlinPayment = (amount, description) => {
  return {
    amount: amount * 100,
    currency_code: 'PEN',
    email: '',
    source_id: 'plin',
    description: description,
    metadata: {
      payment_method: 'plin'
    }
  };
};

// Abrir el Checkout de Culqi
export const openCulqiCheckout = (plan, userEmail) => {
  if (!window.Culqi) {
    console.error('Culqi no está inicializado');
    return;
  }

  const settings = {
    title: plan.name,
    currency: plan.currency,
    amount: plan.amount,
    order: `order_${Date.now()}`,
    email: userEmail,
    
    // Configuración de la ventana de checkout
    options: {
      lang: 'es',
      installments: false,
      paymentMethods: {
        tarjeta: true,
        yape: true,
        billetera: true,
        bancaMovil: true,
        cuotealo: false
      },
      style: {
        logo: 'https://truehomosapiens.com/logo.png',
        bannerColor: '#3B82F6',
        buttonBackground: '#3B82F6',
        buttonText: '#FFFFFF',
        buttonHover: '#2563EB',
        linksColor: '#3B82F6'
      }
    }
  };

  window.Culqi.settings(settings);
  window.Culqi.open();
};

// Validar estado de suscripción
export const validateSubscription = async (userId) => {
  try {
    const response = await fetch('/.netlify/functions/validate-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userId })
    });

    if (!response.ok) {
      throw new Error('Error validando suscripción');
    }

    return await response.json();
  } catch (error) {
    console.error('Error validando suscripción:', error);
    return { active: false, plan: 'free' };
  }
};

// Cancelar suscripción
export const cancelSubscription = async (subscriptionId) => {
  try {
    const response = await fetch('/.netlify/functions/cancel-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ subscriptionId })
    });

    if (!response.ok) {
      throw new Error('Error cancelando suscripción');
    }

    return await response.json();
  } catch (error) {
    console.error('Error cancelando suscripción:', error);
    throw error;
  }
};

export default {
  initCulqi,
  configureCulqi,
  createCardToken,
  openCulqiCheckout,
  validateSubscription,
  cancelSubscription,
  SUBSCRIPTION_PLANS
};